'use client'

import { useCallback, useState } from 'react'

export const useRecommendationIntersection = (): {
  handleIntersection: () => void
  intersected: boolean
} => {
  const [intersected, setIntersected] = useState(false)

  const handleIntersection = useCallback(() => {
    setIntersected(true)
  }, [])

  return { handleIntersection, intersected }
}
